/**
 * Accounts Payable Feature API
 */

import apiClient from '../../../shared/services/apiClient';

export const accountsPayableAPI = {
  getAll: (params) => apiClient.get('/accounts-payable', { params }),
  getById: (id) => apiClient.get(`/accounts-payable/${id}`),
  getSummary: (params) => apiClient.get('/accounts-payable/summary', { params }),
  getAging: (params) => apiClient.get('/accounts-payable/aging', { params }),
  create: (data) => apiClient.post('/accounts-payable', data),
  update: (id, data) => apiClient.put(`/accounts-payable/${id}`, data),
  delete: (id) => apiClient.delete(`/accounts-payable/${id}`),
  recordPayment: (id, data) => apiClient.post(`/accounts-payable/${id}/payments`, data),
  deletePayment: (id, paymentId) => apiClient.delete(`/accounts-payable/${id}/payments/${paymentId}`),
};

export default accountsPayableAPI;

